"use client"

import { Sheet } from "@instacover/ui-web"
import { Maybe } from "@instacover/utils"
import { IconCode } from "@tabler/icons-react"
import { useState } from "react"

import { Spacer } from "@/components/Spacer"

import { DevtoolsImpersonate } from "./DevtoolsImpersonate"

type Props = {
  users: { email: Maybe<string>; id: string }[]
}

export function DevtoolsDialog(props: Props) {
  const { users } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Sheet.Root open={isOpen} onOpenChange={setIsOpen}>
        <Sheet.Trigger className="fixed right-0 bottom-20 z-50 flex size-8 items-center justify-center rounded-l-md bg-slate-200 hover:bg-slate-300">
          <IconCode className="size-4 text-slate-700" />
        </Sheet.Trigger>

        <Sheet.Content>
          <Sheet.Header>
            <Sheet.Title>Devtools</Sheet.Title>
          </Sheet.Header>

          <Spacer className="h-8" />

          <DevtoolsImpersonate onClose={() => setIsOpen(false)} users={users} />
        </Sheet.Content>
      </Sheet.Root>
    </>
  )
}
